/**
 * Utility functions for file operations
 */

/**
 * Get the appropriate file extension based on output format
 */
export const getFileExtension = (format: string): string => {
  const normalized = format.toLowerCase();
  if (normalized === 'csv') return 'csv';
  // Markdown and text formats are downloaded as JSON (containing formatted content in body)
  if (normalized === 'markdown') return 'json';
  if (normalized === 'text') return 'json';
  return 'json';
};
